import React, { Component } from 'react'
import Joi from 'joi-browser'
import './style.scss'
import { supabase } from '../../supabase';

class Form extends Component {
    state = {
        fname: '',
        lname: '',
        phone: '',
        curp: '',
        error: {},
        submitted: false
    }

    schema = {
        fname: Joi.string().required().error(errors => {
            errors.forEach(err => {
                err.message = 'Por favor ingresa tu nombre';
            });
            return errors;
        }),

        lname: Joi.string().required().error(errors => {
            errors.forEach(err => {
                err.message = 'Por favor ingresa tu apellido';
            });
            return errors;
        }),

        phone: Joi.string().min(10).required().error(errors => {
            errors.forEach(err => {
                err.message = 'Por favor ingresa un celular válido';
            });
            return errors;
        }),

        curp: Joi.string()
            .regex(/^[A-Z]{4}\d{6}[HM][A-Z]{5}[A-Z0-9]\d$/)
            .required()
            .error(errors => {
                errors.forEach(err => {
                    err.message = 'La CURP no tiene un formato válido';
                });
                return errors;
            })
    }

    changeHandler = event => {
        const error = { ...this.state.error };
        const errorMessage = this.validationProperty(event);

        if (errorMessage) {
            error[event.target.name] = errorMessage;
        } else {
            delete error[event.target.name];
        }

        this.setState({
            [event.target.name]: event.target.value,
            error
        });
    };

    validationProperty = event => {
        const obj = { [event.target.name]: event.target.value };
        const schema = { [event.target.name]: this.schema[event.target.name] };
        const { error } = Joi.validate(obj, schema);
        return error ? error.details[0].message : null;
    };

    validate = () => {
        const options = { abortEarly: false };

        const form = {
            fname: this.state.fname,
            lname: this.state.lname,
            phone: this.state.phone,
            curp: this.state.curp
        };

        const { error } = Joi.validate(form, this.schema, options);
        if (!error) return null;

        const errors = {};
        for (let item of error.details) {
            errors[item.path[0]] = item.message;
        }
        return errors;
    };

    submitHandler = async event => {
        event.preventDefault();

        const error = this.validate();
        if (error) {
            this.setState({ error });
            return;
        }

        const { error: insertError } = await supabase
            .from('prevalidaciones')
            .insert([{
                fname: this.state.fname,
                lname: this.state.lname,
                phone: this.state.phone,
                curp: this.state.curp.toUpperCase()
            }]);

        if (insertError) {
            if (insertError.code === '23505') {
                alert('Esta CURP ya fue registrada');
            } else {
                alert('Error al guardar la información');
            }
            return;
        }

        this.setState({
            fname: '',
            lname: '',
            phone: '',
            curp: '',
            error: {},
            submitted: true
        });

        setTimeout(() => {
            this.setState({ submitted: false });
        }, 5000);
    };

    render() {
        return (
            <form onSubmit={this.submitHandler} className='contactForm'>
                <div className="row">
                    <div className="col-sm-12 col-12">
                        <h4>Pre-validación Inmediata para retirar hasta $35,193.00</h4>
                    </div>
                        <div className="col-sm-6 col-12">
                            <div className="formInput">
                                <input
                                    placeholder="Nombre"
                                    value={this.state.fname}
                                    name="fname"
                                    onChange={this.changeHandler}
                                    className="form-control"
                                    type="text"
                                />
                                {this.state.error.fname && <p>{this.state.error.fname}</p>}
                            </div>
                        </div>

                        <div className="col-sm-6 col-12">
                            <div className="formInput">
                                <input
                                    placeholder="Apellido"
                                    value={this.state.lname}
                                    name="lname"
                                    onChange={this.changeHandler}
                                    className="form-control"
                                    type="text"
                                />
                                {this.state.error.lname && <p>{this.state.error.lname}</p>}
                            </div>
                        </div>

                        <div className="col-sm-6 col-12">
                            <div className="formInput">
                                <input
                                    placeholder="Celular"
                                    value={this.state.phone}
                                    name="phone"
                                    onChange={this.changeHandler}
                                    className="form-control"
                                    type="tel"
                                />
                                {this.state.error.phone && <p>{this.state.error.phone}</p>}
                            </div>
                        </div>

                        <div className="col-sm-6 col-12">
                            <div className="formInput">
                                <input
                                    className="form-control"
                                    value={this.state.curp}
                                    onChange={this.changeHandler}
                                    placeholder="CURP"
                                    name="curp"
                                    style={{textTransform: 'uppercase'}}
                                />
                                {this.state.error.curp && <p>{this.state.error.curp}</p>}
                            </div>
                        </div>

                        <div className="col-12">
                            <button type="submit">Pre-Validar</button>
                            {this.state.submitted && (
                                <p style={{color: 'white', marginTop: '20px'}}>
                                    Gracias por enviar tu información, nos pondremos en contacto contigo a la brevedad
                                    para darte noticias sobre tu retiro. ¡ Nos vemos pronto !
                                </p>
                            )}
                        </div>
                    </div>
            </form>
    );
    }
}

export default Form;
